var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 4.0011C14.211 3.96678 16.3937 4.76581 18.3198 5.91778C20.2571 7.07642 21.998 8.62909 23.3406 10.1947L23.3532 10.2096C24.2156 11.2561 24.2156 12.743 23.3532 13.7894L23.3409 13.804C22.0278 15.3365 20.3048 16.89 18.3692 18.0574C16.4443 19.2184 14.2464 20.0347 11.9988 19.9989C9.75137 20.0336 7.55336 19.2169 5.62859 18.0556C3.69309 16.8877 1.97047 15.334 0.658663 13.8007L0.646847 13.7866C-0.215616 12.7402 -0.215616 11.2533 0.646847 10.2068L0.659368 10.1919C2.001 8.6272 3.7415 7.07499 5.67856 5.91669C7.60446 4.76507 9.78722 3.96625 11.9991 4.0011ZM2.18511 11.4851C1.9382 11.7903 1.9383 12.2036 2.18539 12.5087C3.37872 13.9019 4.93918 15.3037 6.66183 16.3431C8.39354 17.388 10.2263 18.0295 11.9816 17.9989C11.9934 17.9987 12.0052 17.9987 12.0169 17.9989C13.772 18.0304 15.6044 17.3893 17.3362 16.3448C19.0589 15.3058 20.6198 13.9042 21.8148 12.5112C22.0617 12.2062 22.0617 11.793 21.8149 11.4879C20.5938 10.0657 19.0171 8.66525 17.2932 7.63422C15.5598 6.59748 13.7401 5.97088 12.0165 6.00108C12.0048 6.00129 11.993 6.00129 11.9813 6.00108C10.2578 5.97047 8.43818 6.59682 6.70499 7.63321C4.98134 8.6639 3.4052 10.0639 2.18511 11.4851Z",
    fill: "#303141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z",
    fill: "#303141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.7bdbcb9ad7d0a2e04f00c30fefd93a2a.svg";
export { ForwardRef as ReactComponent };